import { actionTypes } from "../_actions/rtkSdkClient.action";

const initialState = {
  instance: null,
};

const rtkSdkClient = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.SAVE_RTK_CLIENT:
      console.log("SAVE_RTK_CLIENT", {...action.data, currentInstance: state.instance })
      return {
        ...state,
        instance: action.data,
      };
    default:
      return state;
  }
};

export default rtkSdkClient;

